import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Wallet, ArrowRight } from "lucide-react";

const money = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const METHOD = { cash_app: "Cash App", zelle: "Zelle", stripe: "Stripe", check: "Check", cash: "Cash", other: "Other", paypal: "PayPal" };
const METHOD_CLASS = { cash_app: "bg-green-100 text-green-700", zelle: "bg-purple-100 text-purple-700", stripe: "bg-indigo-100 text-indigo-700", check: "bg-amber-100 text-amber-700", cash: "bg-lime-100 text-lime-700", other: "bg-slate-100 text-slate-700", paypal: "bg-sky-100 text-sky-800" };
const monthName = (ym) => (ym ? new Date(`${ym}-15T12:00:00`).toLocaleString(undefined, { month: "long", year: "numeric" }) : "");

export const RecentPayments = ({ stats }) => (
  <Card className="bg-white border-0 shadow-lg" data-testid="recent-payments-card">
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <CardTitle className="text-xl flex items-center gap-2"><Wallet className="w-5 h-5 text-green-600" /> Collections</CardTitle>
        <Link to="/reports" className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1" data-testid="recent-payments-report-link">Payments report <ArrowRight className="w-3 h-3" /></Link>
      </div>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="rounded-xl bg-gradient-to-r from-emerald-50 to-green-100 p-4">
        <p className="text-xs uppercase tracking-wide text-emerald-700">Collected in {monthName(stats.collected_month)}</p>
        <p className="text-3xl font-bold text-emerald-800" data-testid="collected-this-month">{money(stats.collected_this_month)}</p>
        <p className="text-xs text-emerald-700">{stats.collected_this_month_count || 0} payment{stats.collected_this_month_count === 1 ? "" : "s"} this month</p>
      </div>
      <div>
        <p className="text-sm font-semibold text-slate-700 mb-2">Recent payments</p>
        {(stats.recent_payments || []).length === 0 ? <p className="text-sm text-slate-400" data-testid="recent-payments-empty">No payments recorded yet</p> : (
          <div className="divide-y" data-testid="recent-payments-list">
            {stats.recent_payments.map((p) => (
              <div key={p.id} className="flex items-center justify-between py-2 text-sm" data-testid="recent-payment-row">
                <div className="min-w-0">
                  <p className="font-medium text-slate-800 truncate">{p.customer_name} <span className="text-slate-400 font-normal">· {p.invoice_number}</span></p>
                  <p className="text-xs text-slate-500">{p.date}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Badge className={`${METHOD_CLASS[p.method] || METHOD_CLASS.other} text-xs`}>{METHOD[p.method] || p.method}</Badge>
                  <span className="font-bold text-green-700">{money(p.amount)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </CardContent>
  </Card>
);
